export class CatComponent {

    public componentId?:string;
    public componentName?:string;
    public componentURL?:string;
    public componentIcon?:string;
    public componentParent?:string;
    public componentType?:string;
    public pathComponent?:string;
    public canActivate?:string;
    public classComponent?:string;
    public activeId?:boolean;
    public roles?:Array<string>;
    public componentChild?:Array<CatComponentChild>;
}

export class CatComponentChild {
    public componentId?:string;
    public componentName?:string;
    public componentURL?:string;
    public componentIcon?:string;
}